import { KMS_RESPONSE_PUBLIC_KEY_PEM } from "@/config/kmsResponsePublicKey";
import { kmsStableStringify } from "@/utils/kmsStableJson";

const MAX_TS_SKEW_MS = 5 * 60 * 1000;

function pemSpkiToArrayBuffer(pem) {
  const b64 = pem.replace(/-----[^-]+-----/g, "").replace(/\s+/g, "");
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++)
    bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

let _importedKey = null;

async function getVerifyKey() {
  if (_importedKey)
    return _importedKey;
  const spki = pemSpkiToArrayBuffer(KMS_RESPONSE_PUBLIC_KEY_PEM);
  _importedKey = await crypto.subtle.importKey("spki", spki, { name: "RSASSA-PKCS1-v1_5", hash: "SHA-256" }, false, ["verify"]);
  return _importedKey;
}

function b64ToBuf(b64) {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++)
    bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

export async function verifyKmsSignedEnvelope(raw) {
  if (!raw || typeof raw !== "object")
    throw new Error("KMS_BAD_ENVELOPE");
  const sv = raw._sv;
  if (sv !== 2 || raw._d === void 0 || raw._ts === void 0 || !raw._sig)
    throw new Error("KMS_BAD_ENVELOPE");
  if (typeof crypto === "undefined" || !crypto.subtle)
    throw new Error("KMS_NO_CRYPTO");
  const ts = Number(raw._ts);
  if (!Number.isFinite(ts) || Math.abs(Date.now() - ts) > MAX_TS_SKEW_MS)
    throw new Error("KMS_STALE_ENVELOPE");
  const payload = kmsStableStringify(raw._d);
  const msg = `${ts}.${payload}`;
  const key = await getVerifyKey();
  const ok = await crypto.subtle.verify("RSASSA-PKCS1-v1_5", key, b64ToBuf(String(raw._sig)), new TextEncoder().encode(msg));
  if (!ok)
    throw new Error("KMS_SIG_FAIL");
  return raw._d;
}
